import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ScreenReaderOnly from '../Accessibility/ScreenReaderOnly/ScreenReaderOnly';

const AverageRating = ({ className, rating, stars }) => <div className={className}>
    <ScreenReaderOnly>
      <span className="u-hide-visually">
        Product rated {rating} out of {stars}
      </span>
    </ScreenReaderOnly>
  </div>

export default AverageRating;

AverageRating.propTypes = {
  className: PropTypes.string,
  rating: PropTypes.number.isRequired,
  stars: PropTypes.number.isRequired,
};

AverageRating.defaultProps = {
  className: '',
};
